export const zoomedContainerClassName = 'content-zoomed';

const GAME_AUTO_SCROLL_AMOUNT = 5;
const GAME_TRANSPORT_PATH_AUTO_SCROLL_AMOUNT = 10;
const GAME_AUTO_SCROLL_THRESHOLD = 50;

const INTRO_AUTO_SCROLL_AMOUNT = 10;
const INTRO_AUTO_SCROLL_THRESHOLD_TOP = 150;
const INTRO_AUTO_SCROLL_THRESHOLD_BOTTOM = 10;

const TOLERANCE_FACTOR = 3;

class ZoomScrollManager {
  constructor(activityContainerClassname = 'content', onToleranceChangedCallback = () => {}) {
    this.activityContainerClassname = activityContainerClassname;
    this.onToleranceChangedCallback = onToleranceChangedCallback;
    this.gameScrollTreshold = GAME_AUTO_SCROLL_THRESHOLD;
    this.gameScrollAmount = GAME_AUTO_SCROLL_AMOUNT;
  }

  getZoomFactor = () => (window.outerWidth - 8) / window.innerWidth; // TODO browser compatibility

  isZoomed = () => this.zoomFactor > 1;

  getZoomToleranceFactor = () => (this.isZoomed() ? TOLERANCE_FACTOR : 1);

  initialize = () => {
    this.setZoomParams();
    this.setZoomContainerClass();
    this.registerWindowResizeEvents();
  };

  setZoomParams = () => {
    this.zoomFactor = this.getZoomFactor();
    this.toleranceFactor = this.getZoomToleranceFactor();
    this.onToleranceChangedCallback(this.toleranceFactor);
  };

  setZoomContainerClass = () => {
    const gameContainer = document.querySelector(`.${this.activityContainerClassname}`);

    if (!gameContainer) {
      return;
    }

    if (this.isZoomed()) {
      gameContainer.classList.add(zoomedContainerClassName);
    } else {
      gameContainer.classList.remove(zoomedContainerClassName);
    }
  };

  onWindowResize = () => {
    this.setZoomParams();
    this.setZoomContainerClass();
  };

  registerWindowResizeEvents = () => {
    window.addEventListener('resize', this.onWindowResize);
  };

  removeWindowResizeEvents = () => {
    window.removeEventListener('resize', this.onWindowResize);
  };

  resetAutoScrollPosition = () => {
    const container = document.querySelector(`.${zoomedContainerClassName}`);

    if (!container) {
      return;
    }

    container.scroll(0, 0);
  };

  handleGameAutoScroll = (cursorY, isTransportPath) => {
    const container = document.querySelector(`.${zoomedContainerClassName}`);

    if (!container) {
      return;
    }

    const scrollAmount = isTransportPath
      ? GAME_TRANSPORT_PATH_AUTO_SCROLL_AMOUNT
      : this.gameScrollAmount;

    if (container.clientHeight + container.scrollTop - cursorY <= this.gameScrollTreshold) {
      container.scroll(0, container.scrollTop + scrollAmount);
    } else if (cursorY - container.scrollTop <= this.gameScrollTreshold) {
      container.scroll(0, container.scrollTop - scrollAmount);
    }
  };

  handleIntroAutoScroll = cursorY => {
    const container = document.querySelector(`.${zoomedContainerClassName}`);

    if (!container) {
      return;
    }

    if (
      container.clientHeight + container.scrollTop - cursorY <=
      INTRO_AUTO_SCROLL_THRESHOLD_BOTTOM
    ) {
      container.scroll(0, container.scrollTop + INTRO_AUTO_SCROLL_AMOUNT);
    } else if (cursorY - container.scrollTop <= INTRO_AUTO_SCROLL_THRESHOLD_TOP) {
      container.scroll(0, container.scrollTop - INTRO_AUTO_SCROLL_AMOUNT);
    }
  };

  onScrollParamsChanged = ({ scrollAmount, scrollThreshold }) => {
    this.gameScrollAmount = scrollAmount;
    this.gameScrollTreshold = scrollThreshold;
  };
}

export default ZoomScrollManager;
